import { OperationResult } from '@tb/auth';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError, Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators/catchError';
import { environment } from 'src/environments/environment';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { LoginService } from './login.service';
import { UrlMaker } from 'src/app/commons/url-maker';
import { StoreRole } from 'src/app/model/store-role';

@Injectable()
export class StoreRolesService {
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    obj = {};
    isSessionStorage: boolean;
    storeApiUrl: string;
    storeRoles: string[] = [];
    public IsInternal: boolean = false;
    public isAmazonDSP_Partner: boolean = false;
    public isPartnerEditor: boolean = false;
    public isCMSAdmin: boolean = false;
    public isEndUser: boolean = false;
    public isMagoWeb_Partner: boolean = false;
    public isMagoCloud_Partner: boolean = false;
    public isMago4_Partner: boolean = false;
    public isReseller: boolean = false;
    public isBetaTester: boolean = false;
    public isWebSiteAdmin: boolean = false;
    public isZucchettiAccount: boolean = false;
    public isCASAccount: boolean = false;
    public storeRoles$ = new BehaviorSubject<string[]>(this.storeRoles);

    constructor(private http: HttpClient, public loginService: LoginService) {
        this.storeApiUrl = environment.settings.storeApiUrl;
        this.isSessionStorage = environment.auth.sessionStorage;
    }

    async removeRoleFromSession(roleName: string, accountName: string) {
        let json;
        if (this.isSessionStorage) {
            json = sessionStorage.getItem('M4_store_roles_' + accountName);
        } else {
            json = localStorage.getItem('M4_store_roles_' + accountName);
        }
        if (!json || json.length == 0) return;

        this.storeRoles = JSON.parse(json); //.split(',');
        let index = this.storeRoles.findIndex((x) => x === roleName);
        if (index == -1) return;
        //rimuovo il ruolo dall'array
        this.storeRoles.splice(index, 1);

        if (this.isSessionStorage) {
            sessionStorage.removeItem('M4_store_roles_' + accountName);
            sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
        } else {
            localStorage.removeItem('M4_store_roles_' + accountName);
            localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
        }

        this.refreshCheckRoles(this.storeRoles);
        this.storeRoles$.next(this.storeRoles);
    }

    async saveSTRolesInSession(accountName: string) {
        let json;
        this.storeRoles = [];
        //recupero i ruoli dal DB
        let opResult: OperationResult = await this.getAllST_Roles(accountName);
        if (!opResult.Result) this.loginService.logOff$.next();
        let st_Roles: Array<StoreRole> = opResult.Content as Array<StoreRole>;

        if (this.isSessionStorage) {
            json = sessionStorage.getItem('M4_store_roles_' + accountName);
        } else {
            json = localStorage.getItem('M4_store_roles_' + accountName);
        }

        if (!json || json.length == 0) {
            st_Roles.forEach((element) => {
                let r: string = this.storeRoles.find((x) => x == element.RoleName);
                if (r == undefined || r.length == 0) this.storeRoles.push(element.RoleName);
            });
            if (this.isSessionStorage) {
                sessionStorage.removeItem('M4_store_roles_' + accountName);
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
                json = sessionStorage.getItem('M4_store_roles_' + accountName);
            } else {
                localStorage.removeItem('M4_store_roles_' + accountName);
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
                json = localStorage.getItem('M4_store_roles_' + accountName);
            }
        } else {
            this.storeRoles = JSON.parse(json); //.split(',');
            st_Roles.forEach((p) => {
                if (!this.storeRoles.find((x) => x == p.RoleName)) this.storeRoles.push(p.RoleName);
                else {
                    //se c'è ed è disabilitato lo devo togliere
                    if (p.Disabled == 1) this.storeRoles.splice(this.storeRoles.indexOf(p.RoleName), 1);
                }
            });

            if (this.isSessionStorage) {
                sessionStorage.removeItem('M4_store_roles_' + accountName);
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            } else {
                localStorage.removeItem('M4_store_roles_' + accountName);
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            }

            this.refreshCheckRoles(this.storeRoles);
            this.storeRoles$.next(this.storeRoles);
        }
    }
    refreshCheckRoles(roles: Array<string>) {
        this.IsInternal = roles.find((x) => x === ST_Roles[ST_Roles.ST_INTERNAL]) != null;
        this.isAmazonDSP_Partner = roles.find((x) => x === ST_Roles[ST_Roles.ST_PARTNER_ADSP]) != null;
        this.isPartnerEditor = roles.find((x) => x === ST_Roles[ST_Roles.ST_INTERNAL_PARTNERSHIP_MNG]) != null;
        this.isCMSAdmin = roles.find((x) => x === ST_Roles[ST_Roles.ST_CMSADMIN]) != null;
        this.isEndUser = roles.find((x) => x === ST_Roles[ST_Roles.ST_ENDUSER]) != null;
        this.isMagoWeb_Partner = roles.find((x) => x === ST_Roles[ST_Roles.ST_PARTNER_MAGOWEB]) != null;
        this.isMagoCloud_Partner = roles.find((x) => x === ST_Roles[ST_Roles.ST_PARTNER_MAGOCLOUD]) != null;
        this.isMago4_Partner = roles.find((x) => x === ST_Roles[ST_Roles.ST_PARTNER_MAGO4]) != null;
        this.isReseller = roles.find((x) => x === ST_Roles[ST_Roles.ST_RESELLER]) != null;
        this.isBetaTester = roles.find((x) => x === ST_Roles[ST_Roles.ST_BETATESTER]) != null;
        this.isWebSiteAdmin = roles.find((x) => x === ST_Roles[ST_Roles.ST_WEBSITEADMIN]) != null;
        this.isZucchettiAccount = roles.find((x) => x === ST_Roles[ST_Roles.ST_ZUCCHETTIACCOUNT]) != null;
        this.isCASAccount = roles.find((x) => x === ST_Roles[ST_Roles.ST_CASACCOUNT]) != null;
    }

    setST_Roles(accountName: string, roleName: string) {
        let json;
        let roles: string[] = [];
        if (this.isSessionStorage) {
            json = sessionStorage.getItem('M4_store_roles_' + accountName);
        } else {
            json = localStorage.getItem('M4_store_roles_' + accountName);
        }
        if (!json || json.length == 0) {
            roles.push(roleName);
            if (this.isSessionStorage) {
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(roles));
            } else {
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(roles));
            }
        } else {
            roles = JSON.parse(json); //.split(',');
            let exists = roles.find((x) => x === roleName) != undefined;
            if (!exists) {
                roles.push(roleName);
                roles.forEach((p) => {
                    if (!this.storeRoles.find((x) => x == p)) this.storeRoles.push(p);
                });
            }
            if (this.isSessionStorage) {
                sessionStorage.removeItem('M4_store_roles_' + accountName);
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            } else {
                localStorage.removeItem('M4_store_roles_' + accountName);
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            }
        }
        this.storeRoles = Object.assign(roles);
        this.refreshCheckRoles(roles);
        this.storeRoles$.next(this.storeRoles);
    }

    getST_Roles(accountName: string) {
        let json;
        let roles: string[] = [];
        if (this.isSessionStorage) {
            json = sessionStorage.getItem('M4_store_roles_' + accountName);
        } else {
            json = localStorage.getItem('M4_store_roles_' + accountName);
        }
        if (!json || json.length == 0) {
            if (this.isSessionStorage) {
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(roles));
            } else {
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(roles));
            }
        } else {
            roles = JSON.parse(json); //.split(',');
            if (this.isSessionStorage) {
                sessionStorage.removeItem('M4_store_roles_' + accountName);
                sessionStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            } else {
                localStorage.removeItem('M4_store_roles_' + accountName);
                localStorage.setItem('M4_store_roles_' + accountName, JSON.stringify(this.storeRoles));
            }
        }
        this.storeRoles = Object.assign(roles);
    }

    public async setDefaultRoles(accountName: string, companytype: number, partnershiplevel: string) {
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('setDefaultRole').toString();

        const jobj = {
            accountName: accountName,
            companytype: companytype,
            partnershiplevel: partnershiplevel,
        };

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http
            .post<OperationResult>(url, JSON.stringify(jobj), { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in setDefaultRole')))
            .toPromise();
    }

    public getAllST_Roles(accountName: string): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('getAllRoles').appendSegment(accountName).toString();

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http
            .get<OperationResult>(url, { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getAllSTRoles')))
            .toPromise();
    }

    public setOrRemoveST_Roles(accountName: string, selectedAccount: string, roles: StoreRole[]): Promise<OperationResult> {
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('setRoles').toString();

        const jobj = {
            accountName: accountName,
            selectedAccount: selectedAccount,
            roles: roles,
        };
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http
            .post<OperationResult>(url, JSON.stringify(jobj), { headers })
            .pipe(catchError((error: HttpErrorResponse) => throwError(error || 'Server error in getAllSTRoles')))
            .toPromise();
    }

    public Clear() {
        this.storeRoles = [];
        this.IsInternal = false;
        this.isAmazonDSP_Partner = false;
        this.isPartnerEditor = false;
        this.isCMSAdmin = false;
        this.isEndUser = false;
        this.isMagoWeb_Partner = false;
        this.isMagoCloud_Partner = false;
        this.isMago4_Partner = false;
        this.isReseller = false;
        this.isBetaTester = false;
        this.isWebSiteAdmin = false;
        this.isZucchettiAccount = false;
        this.isCASAccount = false;
        this.storeRoles$.next(this.storeRoles);
    }
}
//aggiungere la stringa anche nella tabella
export enum ST_Roles {
    ST_ORDER_AREA,
    ST_NFS_AREA,
    ST_ONPREM_AREA,
    ST_INCIDENT_AREA,
    ST_ACCOUNT_AREA,
    ST_RESELLER,
    ST_BETATESTER,
    PLATIMUN_MC,
    GOLD_MC,
    SILVER_MC,
    ST_ENDUSER,
    ST_INTERNAL,
    ST_INTERNAL_PARTNERSHIP_MNG,
    ST_PARTNER_ADSP,
    ST_CMSADMIN,
    ST_PARTNER_MAGOWEB,
    ST_PARTNER_MAGOCLOUD,
    ST_PARTNER_MAGO4,
    ST_WEBSITEADMIN,
    ST_ZUCCHETTIACCOUNT,
    ST_CASACCOUNT,
}
